import { render, staticRenderFns } from "./Biddetail.vue?vue&type=template&id=9ce9f3d4&scoped=true&"
import script from "./Biddetail.vue?vue&type=script&lang=js&"
export * from "./Biddetail.vue?vue&type=script&lang=js&"
import style0 from "./Biddetail.vue?vue&type=style&index=0&id=9ce9f3d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce9f3d4",
  null
  
)

export default component.exports